import { setSpecificMessage, check } from "valibot";
setSpecificMessage(
  check,
  (issue) => `Valeur invalide: reçu ${issue.received}`,
  "fr"
);